module.exports = __webpack_public_path__ + "static/media/tk.c868bd90.svg";